import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { toast } from '@livable/saas-react-components';
import { AddressElement, PaymentElement, useElements, useStripe } from '@stripe/react-stripe-js';
import { observer } from 'mobx-react-lite';
import { useStore } from 'src/stores';
import useStyles from './styles';
import { Button } from '@mui/material';
import { sleep } from 'src/utils/sleep';
import { useTranslation } from 'react-i18next';
import { BackdropLoader } from '@livable/saas-react-components';
export const StripeForm = observer(_ref => {
  let handleModalClose = _ref.handleModalClose;
  const store = useStore();
  const stripe = useStripe();
  const classes = useStyles();
  const elements = useElements();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isPayProcessing = _useState2[0],
    setIsPayProcessing = _useState2[1];
  const getAutopayMethod = async () => {
    const resp = await store.payment.getAutopayMethodAsync.run();
    return resp;
  };
  const getPaymentMethods = async () => {
    const resp = await store.payment.getPaymentMethodsAsync.run();
    return resp;
  };
  const handleSubmit = async event => {
    event.preventDefault();
    setIsPayProcessing(true);
    if (!stripe || !elements) {
      toast('error', {
        body: ['Stripe error']
      });
      setIsPayProcessing(false);
      handleModalClose();
      return;
    }
    const result = await stripe.confirmSetup({
      elements,
      confirmParams: {},
      redirect: 'if_required'
    });
    await sleep(3000);
    if (result.error) {
      toast('error', {
        body: [result.error.message]
      });
    } else {
      toast('success', {
        body: ['The payment method has successfully updated and will be available in a few moments.']
      });
      setTimeout(() => {
        handleModalClose();
      }, 500);
      clearTimeout();
      setTimeout(() => {
        Promise.all([getAutopayMethod(), getPaymentMethods()]);
      }, 2000);
      clearTimeout();
    }
    setIsPayProcessing(false);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("form", {
    onSubmit: handleSubmit
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PaymentElement, {
    options: {
      paymentMethodOrder: ['us_bank_account']
    }
  }), /*#__PURE__*/React.createElement(AddressElement, {
    options: {
      mode: 'billing'
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.modalFooter
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerEven
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerWrapper
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    onClick: handleModalClose,
    'custom-attribute': '303-StripeForm'
  }, t('buttons.cancel'))), /*#__PURE__*/React.createElement("div", {
    className: classes.footerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerButton
  }, /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    variant: "contained",
    'custom-attribute': '304-StripeForm'
  }, t('buttons.submit'))))))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isPayProcessing || store.payment.getPublicKeyAsync.inProgress || store.payment.getSetupIntentWithSubscriptionAsync.inProgress
  }));
});